import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { Text } from 'marketing-site/src/library/elements/Text'
import { RichText } from 'marketing-site/src/mvp/library/elements/RichText'
import { IProps } from './index'

export const SpotlightDrawersSlide: React.FC<IProps> = ({ title, subhead, media }) => {
  return (
    <>
      <div className="spotlight-drawers-slide" data-testid="spotlight-drawers-slide">
        <div className="spotlight-drawers-slide__media">
          <div className="spotlight-drawers-slide__media-inner">{media}</div>
        </div>
        <div className="spotlight-drawers-slide__content">
          <h3 className="spotlight-drawers-slide__title">
            <Text size="body-bold">{title}</Text>
          </h3>
          {subhead && (
            <div className="spotlight-drawers-slide__subhead">
              <Text size="body">
                <RichText document={subhead} />
              </Text>
            </div>
          )}
        </div>
      </div>

      <style jsx>
        {`
          .spotlight-drawers-slide {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            grid-column-gap: 1rem;
            grid-row-gap: 3.5rem;
            border-radius: 1rem;
            overflow: hidden;

            &__media {
              grid-column: 1/-1;
              // Will prevent the element from exceeding the grid’s limits.
              min-width: 0;
            }

            &__media-inner {
              width: 100%;
              height: 0;
              padding-bottom: 100%;
              border-radius: 1rem;
              overflow: hidden;
              position: relative;

              :global(> *),
              :global(> .video-player-wrapper) {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                object-fit: cover;
              }

              :global(> * > *) {
                width: 100%;
                height: 100%;
                position: absolute;
                object-fit: cover;
              }
            }

            &__content {
              grid-column: 1/-1;
              text-align: center;
              // Will prevent the element from exceeding the grid’s limits.
              min-width: 0;
            }

            &__subhead {
              margin-top: 0.5rem;
            }

            :global(.cta-link) {
              margin-top: 2rem;
            }
          }

          @media (${mq.tablet}) {
            .spotlight-drawers-slide {
              grid-template-columns: repeat(12, 1fr);
              grid-column-gap: 1.75rem;
              grid-row-gap: 4.5rem;
              border-radius: 1.5rem;

              &__media,
              &__content {
                grid-column: 3/-3;
              }

              &__media-inner {
                border-radius: 1.5rem;
              }
            }
          }

          @media (${mq.desktop}) {
            .spotlight-drawers-slide {
              grid-column-gap: 2rem;

              &__media {
                grid-column: 1/-1;
              }

              &__content {
                display: none;
              }

              &__title {
                margin-top: 2.5rem;
              }

              &__subhead {
                margin-top: 0.75rem;
              }

              :global(.cta-link) {
                margin-top: 1.75rem;
              }
            }
          }
        `}
      </style>
    </>
  )
}
